type videoId = {
  [key: string]: string
}

const videoIdMap: videoId = {
  es: 'xftrd19wgj',
  it: '120qr2eqic',
  fr: 'ksdxtwf3ri',
  de: 'ff2v1sraq9',
  pt: 'td249y6l2l',
  en: 'iidmb56sym',
  'en-gb': 'xo2d28kyhj',
  'pt-br': 'rjf779bmyn',
  'es-mx': 'qoad3kqp6l',
  'es-ar': 'qoad3kqp6l',
  'es-cl': 'qoad3kqp6l',
  'es-co': 'qoad3kqp6l',
}

export const getVideoId = (lang: string): string => (videoIdMap[lang] || videoIdMap.en) as string
